import RegisterBaseRoute from 'uplisting-frontend/pods/register/base-route';

export default class RegisterInfoRoute extends RegisterBaseRoute {}
